import React from 'react';

export const ConfigDesc = (
    <span>
        <span style={{ color: '#FF0' }}>
            注意：在录入任何访视记录前，请先进行访视周期计划设置。<br/>
            只有设置了访视周期计划，才能录入访视<br/>
        </span>
        1.单个访视周期方案时，可直接在访视方案1下配置该访视方<br/>
        案；（添加阶段/周期&gt;&gt;添加访视&gt;&gt;设置次数&gt;&gt;设置违背）；<br/>
        2.多个访视周期方案时，点击访视方案1标签栏旁的+操作，<br/>
        可以复制增加新的访视周期方案；<br/>
        3. 双击访视方案名称，可以重命名；<br/>
        4.点击访视方案标签栏旁的X操作，可以删除该访视方案；<br/>
        5.项目默认开启筛选流程，点击“筛选流程”开关可关闭筛选流程，再次点击可重新开启筛选流程；<br/>
        6.配置完毕后可以预览填写效果；<br/>
        7.访视计划发布后，CRC才能填写。
    </span>
);

export const DateType = {
    DAY: '天',
    WEEK: '周',
    MONTH: '月',
};
export const VisitTypeTimeUnit = {
    DAY: '天',
    HOUR:'小时'
};
export const HourType = {
    HOUR:'小时'
};

export const SymbolType = {
    floor: '-',
    ceil: '+',
};


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/constants.js